/**
 * Wait for timeout.
 * @param delay The number of milliseconds to wait.
 */
const sleep = (delay: number) => {
  return new Promise(resolve => setTimeout(resolve, delay));
};

/**
 * Retries the given function until it succeeds given a number of retries and an interval between them.
 * @param callback Function to call.
 * @param interval Interval in milliseconds.
 * @param numRetries Number of retries.
 */
export const retry = async <T extends () => any>(
  callback: T,
  interval = 1000,
  numRetries = 5,
): Promise<ReturnType<T> | null> => {
  for (let attempt = 0; attempt < numRetries; attempt++) {
    try {
      if (attempt > 0) {
        await sleep(interval);
      }
      return callback();
    } catch (e) {
      // throw on last attempt?
    }
  }

  return null;
};
